import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getDisscount, cleartDisscount, seeplacesPickup, getEcopointsRedeem, removeItem, changeQuantity } from '../../../actions/marketPlaceActions';
import { createPaymentlink } from '../../../actions/PasarelaActions';
import { seeWineries } from '../../../admin/actions/wineryActions';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';
import marketplaceBag from '../../../assets/img//MarketplaceBag.png'
import useMercadoPago from '../../../utils/hooks/useMercadoPago';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';
import PaymentSummary from '../../ShopingBag/PaymentSummary';

import "./ShopingBag.css"
import TitleImg from '../../../utils/components/TitleImg/TitleImg';
import { getLimitReports } from '../../../admin/actions/reportActions';
import localStorage from '../../../utils/hooks/useLocalStorage';
import ProductItem from '../../../admin/containers/Inventory/Consignment/CartConsignmet/ProductItem';

const ShopingBag = ({ bag }) => {
    const dispatch = useDispatch()
    const { userInfo } = useSelector(state => state.userInfo)
    const { wineriesList } = useSelector(state => state.wineriesAdmin)
    const { disscounts, placesPickup, pointsToRedeem, isLoadingPointsToRedeem } = useSelector(state => state.marketPlace)
    const { listOfReportsLimit } = useSelector(state => state.postAdmin)
    const [typeOfDelivery, setTypeOfDelivery] = useState("")
    const [typeOfPay, setTypeOfPay] = useState("")
    const [pointsRedem, setPointsRedem] = useState(0)

    const [deliveryAddress, setDeliveryAddress] = useState("")
    const [deliveryEntityId, setDeliveryEntityId] = useState("")
    const [type, setType] = useState("user")
    const [country, setCountry] = useState("")
    const [location, setLocation] = useState("")
    const [state, setState] = useState("")
    const [city, setCity] = useState("")
    const [phone, setPhone] = useState("")

    useTokenCallback(() => {
        dispatch(getLimitReports())
        dispatch(seeplacesPickup())
        dispatch(getEcopointsRedeem())
    }, [])
    useEffect(() => {

        if (localStorage().getItem('typeProfile') != "user") {
            if (userInfo.representativeID) {
                if (userInfo.representativeID.state === 2) {
                    dispatch(getDisscount('representative'))
                    setType('re')
                }
            }
            if (userInfo.franchiseID) {
                if (userInfo.franchiseID.state === 2) {
                    dispatch(getDisscount('franchise'))
                    setType('fr')
                }
            }
        }

        if (userInfo.warehouseID) {

            setType('wh')
        }

        return () => {
            dispatch(cleartDisscount())
        }
    }, [userInfo])
    const history = useHistory()
    const mp = useMercadoPago()

    const disscount = 0.2;
    const typeUser = "ecotienda"
    const calculateSubTotal = (bag) => {
        let total = 0
        bag.map(product => {
            total = total + (product.quantity * product.unit_price)
        })
        return total
    }
    const calculateTotal = (value) => {

        return (value * (disscounts.length > 0 ? disscounts.map(item => item.value / 100).reduce((prev, next) => prev * next) : 0))

    }
    const pay = () => {
        if (typeOfPay === 'combinacion' && pointsRedem === 0) {
            setTypeOfPay('pesos')
        }
        let id = localStorage().getItem('idProfile')
        let type = localStorage().getItem('typeProfile')

        dispatch(createPaymentlink(
            bag,
            id,
            type,
            typeOfDelivery,
            {
                currentCountry: country,
                currentDepartment: state,
                currentCity: city,
                currentLocation: location,
                currentAddress: deliveryAddress
            },
            phone,
            deliveryEntityId,
            typeOfPay,
            parseInt(pointsRedem),
            mp, history))
    }
    return (//    <TitleImg img={marketplaceBag} height={64} titleHighlight={"EcoBolsa"} />
        <div className='shoping-bag-container'>
            <div className='list-products-bag scroll-menu'>
                {bag.map(item => (
                    <ProductItem 
                    changeAction={changeQuantity}
                    removeAction={removeItem}
                    
                    item={item} />
                ))}
            </div>
            <PaymentSummary
                isLoadingPointsToRedeem={isLoadingPointsToRedeem}
                wareHausesWinery={placesPickup}
                typeOfDelivery={typeOfDelivery} setTypeOfDelivery={setTypeOfDelivery}
                subTotal={calculateSubTotal(bag)}
                total={calculateTotal(calculateSubTotal(bag))}
                pay={pay}
                type={type}
                typeUser={disscounts.length > 0 ? disscounts.map(item => item.to) : ''}
                disscount={disscounts.length > 0 ? disscounts.map(item => item.value / 100).reduce((prev, next) => prev * next) : 0} {...{
                    typeOfPay, setTypeOfPay, listOfReportsLimit, pointsToRedeem, pointsRedem, setPointsRedem, deliveryAddress, setDeliveryAddress
                    , deliveryEntityId, setDeliveryEntityId, country, setCountry, state, setState, city, setCity, location, setLocation, phone, setPhone
                }} />
        </div>

    )
};

export default ShopingBag;
